const genders = ['masculine', 'feminine', 'neuter', 'plural'];

export default genders;


/** WEBPACK FOOTER **
 ** ./tables/nouns/genders/data.js
 **/